import { Outlet, useLocation } from 'react-router-dom';
import { usePlayerData } from '@/hooks/usePlayerData';
import type { AuthUser, PlayerData } from '@/vite-env.d';
import { PlayerSidebar } from './PlayerSidebar';
import '@/styles/home-layout.css';

interface AppShellProps {
  user: AuthUser;
  initialPlayer: PlayerData | null;
}

export function AppShell({ user, initialPlayer }: AppShellProps) {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const { data: player, isLoading, isFetching } = usePlayerData(user.charId);
  const displayPlayer = player ?? initialPlayer;

  if (isHome) {
    return (
      <div className="container-ingame home-page fade-in">
        <PlayerSidebar
          player={displayPlayer}
          charId={user.charId}
          isLoading={(isLoading || isFetching) && !displayPlayer}
        />
        <div className="menu-area" id="main-content">
          <Outlet context={{ user, player: displayPlayer }} />
        </div>
      </div>
    );
  }

  return (
    <Outlet context={{ user, player: displayPlayer }} />
  );
}
